import useTranslator from "../../hooks/useTranslator";
import Form from "react-bootstrap/Form";
import OTPInput from "otp-input-react";
import Cancelimg from "../../assets/img/cancel-01.svg";
import { useState } from "react";
import axiosInstance from "../../services/authWrapper";
import { toast } from "../../helper/common";

const EnterOtpModal = ({
  otp,
  setOtp,
  isGuarantor,
  onClose,
  handleSubmitEditedUser,
  showResend,
  showTimer,
  sendOtpFun,
  verifyOTPHandler,
  verifyOtpLoading,
  email,
}) => {
  const { _t } = useTranslator();
  const [otpSubmitLoading, setOtpSubmitLoading] = useState(false);
  const otpinputChange = (e) => {
    setOtp(e);
  };

  const verifyOTP = async () => {
    const userid = localStorage.getItem("saveduserid");
    const usertype = localStorage.getItem("usertype");
    setOtpSubmitLoading(true);
    await axiosInstance
      .put(
        `${process.env.REACT_APP_SERVER_URL}/users/otp-verify/${userid}`,
        { type: usertype, otp: otp },
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then((res) => {
        if (res?.data?.status === "verified") {
          handleSubmitEditedUser(true);
        }
      })
      .catch((err) => {
        let serverResponse = err;
        toast.error(serverResponse.response.data.msg);
      })
      .finally(() => {
        setOtpSubmitLoading(false);
      });
  };

  return (
    <div
      className={`approvedModal popup-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 wrapper-modal modal-fixed-screen ${
        isGuarantor ? "guarantorBg" : ""
      }`}
      style={{ zIndex: 99 }}
    >
      <div
        className="popup-content2 position-relative popup-content bg-white required-doc-popup enterOtpPopup"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="d-flex custom-mb-3 align-items-center justify-content-between">
          <h2 className="headerOtp">{_t("checkYourEmailForOtp")}</h2>
          <img
            src={Cancelimg}
            alt="icon"
            className="canceicon"
            onClick={onClose}
          />
        </div>
        <p>{_t("anOtpHasBeenSentToYourEmailPleaseCheck")}</p>
        <p className="fw-bold">{email}</p>
        <Form
          onKeyDown={(e) => {
            if (
              e.key === "Enter" &&
              (otp ?? "").length === 6 &&
              !(otpSubmitLoading || verifyOtpLoading)
            ) {
              (verifyOTPHandler ? verifyOTPHandler : verifyOTP)(e);
            }
          }}
          className="loginform otp-Verification otpVerificationModal"
        >
          <OTPInput
            className="forminput"
            value={otp}
            onChange={otpinputChange}
            autoFocus
            OTPLength={6}
            otpType="number"
            disabled={false}
          />
        </Form>
        {showResend ? (
          <>
            <p className="notFindText">
              {_t("cannotFindOtpEmailPleaseCheckSpamAsWellOrTryAgain")}
            </p>
            <p
              onClick={sendOtpFun}
              className="hover-underline resendButton cursor-pointer"
            >
              {_t("resend")}
            </p>
          </>
        ) : (
          <p className="resendOtpText custom-gap-2 align-items-center justify-content-center">
            {_t("resentOtpIn")}
            <span>{showTimer}s</span>
          </p>
        )}
        <button
          disabled={
            (otp ?? "").length === 0 || otpSubmitLoading || verifyOtpLoading
          }
          onClick={verifyOTPHandler ? verifyOTPHandler : verifyOTP}
          className={`btnNext addGuarantorButton nextButtonOtp ${
            showResend ? "resentOptButton" : ""
          }`}
        >
          {_t("next")}
        </button>
      </div>
    </div>
  );
};

export default EnterOtpModal;
